/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-infigo-select',
    templateUrl: './infigo-select.component.html',
    styleUrls: ['./infigo-select.component.scss'],
})
export class InfigoSelectComponent {
    @Input() options = [];
    @Input() value;
    @Output() onChange = new EventEmitter();
    select: any = {};

    changeSelect(option: any): void {
        this.select = option;
        this.onChange.emit(option.value);
    }
}
